let inject = ['$scope', '$uibModalInstance','modalOptions'];

class ModalResponseController {
  constructor ($scope,$uibModalInstance,modalOptions) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalResponseController.$inject = inject;

export default ModalResponseController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/modal-response/modal-response.controller.js
 **/